import { Field } from 'ngx-angular-query-builder'
import { FilterOperators, FieldMetadata, FieldMetadataCollection, FilterFieldProvider } from '@common/filter/filtering';
import { ArrearsField, ArrearsFields } from '../arrears-fields.provider';
import { PropertyTypeModel } from '../models/property-type.model';
import { PropertyGroupModel } from '../models/property-group.model';
import { PropertyLocationModel } from '../models/property-location.model';
import { SubLedgerModel } from '@feature/cash-balances/models/sub-ledger.model';

export class AdminArrearsFilterFieldProvider implements FilterFieldProvider {

  readonly fieldMetaDataCollection: FieldMetadataCollection = new FieldMetadataCollection();

  constructor(
    private readonly propertyTypes: Array<PropertyTypeModel>,
    private readonly propertyGroups: Array<PropertyGroupModel>,
    private readonly propertyLocations: Array<PropertyLocationModel>,
    private readonly subLedgers: Array<SubLedgerModel>,
    private readonly arrearsFields: ArrearsFields) {
    this.initialiseFields();
  }

  private getQueryBuilderCategories(array: Array<any>, callback: (any) => any): any[] {
    let result = [];
    array.forEach((item) => {
      result.push(callback(item));
    });

    return result;
  }

  private initialiseFields() {


    const clientParentRef = { name: 'Client Parent', type: 'number', operators: FilterOperators.AdminScalar };
    this.fieldMetaDataCollection.set(clientParentRef.name, new FieldMetadata('ClientParentRef', clientParentRef ));

    const clientRef = { name: 'Client', type: 'number', operators: FilterOperators.AdminScalar };
    this.fieldMetaDataCollection.set(clientRef.name, new FieldMetadata('ClientRef', clientRef ));

    const addFieldToFilterFieldMetadata = (field: ArrearsField, items: any[]) => {
      const filterField = {
        name: field.label,
        type: 'category',
        operators: FilterOperators.CategoryDefaults,
        options: items
      };
      this.fieldMetaDataCollection.set(filterField.name, new FieldMetadata(field.fieldName, filterField));
    };

    addFieldToFilterFieldMetadata(this.arrearsFields.propertyType, this.getQueryBuilderCategories(this.propertyTypes, (propertyType: PropertyTypeModel) => {
      return {
        label: `${propertyType.Code} - ${propertyType.Description}`,
        name: `${propertyType.Code} - ${propertyType.Description}`,
        value: propertyType.Description
      }
    }));

    addFieldToFilterFieldMetadata(this.arrearsFields.propertyGroup, this.getQueryBuilderCategories(this.propertyGroups, (propertyGroup: PropertyGroupModel) => {
      return {
        label: `${propertyGroup.Code} - ${propertyGroup.Description}`,
        name: `${propertyGroup.Code} - ${propertyGroup.Description}`,
        value: propertyGroup.Description
      }
    }));

    addFieldToFilterFieldMetadata(this.arrearsFields.location, this.getQueryBuilderCategories(this.propertyLocations, (propertyLocation: PropertyLocationModel) => {
      return {
        label: `${propertyLocation.Code} - ${propertyLocation.Description}`,
        name: `${propertyLocation.Code} - ${propertyLocation.Description}`,
        value: propertyLocation.Description
      }
    }));

    const propertyRef = { name: 'Property', type: 'number', operators: FilterOperators.AdminScalar };
    this.fieldMetaDataCollection.set(propertyRef.name, new FieldMetadata('PropertyRef', propertyRef ));

    const ageCategories = ['Up to 30', '31-60', '61-90', '91-120', '120+'];
    const ageOptions = ageCategories.map(category => ({
      label: category,
      name: category,
      value: category
    }));
    const age = {
      name: 'Age',
      type: 'category',
      operators: FilterOperators.CategoryDefaults,
      options: ageOptions
    };
    this.fieldMetaDataCollection.set(age.name, new FieldMetadata('Age', age));

    const total = { name: 'O/S Amount', type: 'number', operators: FilterOperators.AdminScalar };
    this.fieldMetaDataCollection.set(total.name, new FieldMetadata('Total', total ));

    const paymentPlan = {
      name: this.arrearsFields.paymentPlan.label,
      type: 'string',
      operators: FilterOperators.AdminStringDefaults
    };
    this.fieldMetaDataCollection.set(paymentPlan.name, new FieldMetadata(this.arrearsFields.paymentPlan.fieldName, paymentPlan));

    addFieldToFilterFieldMetadata(this.arrearsFields.subLedger, this.getQueryBuilderCategories(this.subLedgers, (subLedger: SubLedgerModel) => {
      return {
        label: `${subLedger.Code} - ${subLedger.Description}`,
        name: `${subLedger.Code} - ${subLedger.Description}`,
        value: subLedger.Description
      }
    }));
  }

  getFilterFields(): Array<Field> {
    return this.fieldMetaDataCollection.getFilterFields();
  }


  getFilterField(fieldName: string): Field {
    return this.fieldMetaDataCollection.getFilterField(fieldName);
  }

  getFieldNameFromLabel(label: string): string {
    return this.fieldMetaDataCollection.getFieldNameFromLabel(label);
  }

}
